import { State } from '../../models/common/family-profile';
import usStates from '../../../assets/data/us-states.json';

/** Canonical US states list (name + postal abbreviation), sourced from
 *  assets/data/us-states.json. Single source of truth for every state dropdown. */
export const US_STATES: State[] = usStates;
